module.exports = __webpack_public_path__ + "static/item--ac--f3@3x.4a60013c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--ac--f3@3x.png
// module id = 621
// module chunks = 126511778744290